import { runtime } from './bridge';

export function isTextEditing(event: KeyboardEvent) {
  const target = event.composedPath().find(node => node && (node as Element).nodeType === 1) as Element | undefined;
  return Boolean(target?.closest('textarea,[contenteditable]:not([contenteditable="false"]),input:not([type="range"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="file"])'));
}

// Consume both phases so native button/checkbox/menu activation cannot run on
// keyup. The audio changes exactly once, on a non-repeating keydown.
export function playbackSpace(event: KeyboardEvent) {
  if (event.code !== 'Space' && event.key !== ' ') return false;
  if (document.querySelector('[data-shortcut-recording="true" ]')) return false;
  if (event.isComposing || event.keyCode === 229 || event.ctrlKey || event.metaKey || event.altKey || isTextEditing(event)) return false;
  if (!runtime.access.authenticated) return false;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (event.type === 'keydown' && !event.repeat) runtime.togglePlay();
  return true;
}
